export default function length(value, { min = 0, max = 100, locale = {} }) {
  if (value && (value.length < min || value.length > max)) {
    return locale.length || 'length';
  }

  return null;
}
